import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import ChatComponent from './Chat';
import { ChatContainer } from './styles/ChatContainer.styles';
import { FabButton } from './styles/ChatButtons.styles';
import { WhiteChatIcon } from './styles/ChatIcons.styles';

const ChatWidget = () => {
  const location = useLocation();
  const { status } = useSelector((state: RootState) => state.uploadAndAnalyzeAiState);
  const [showChat, setShowChat] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [bottomOffset, setBottomOffset] = useState(24);

  const shouldShowChatWidget =
    location.pathname === '/optimizer-list' &&
    (status === 'success' || status === 'failed');

  useEffect(() => {
    const hasVisited = localStorage.getItem('hasVisitedChat');
    if (!hasVisited) {
      localStorage.setItem('hasVisitedChat', 'true');
    }
  }, []);

  useEffect(() => {
    const handleBottomPanelFixed = (event: Event) => {
      const customEvent = event as CustomEvent<{ isFixed: boolean }>;
      setBottomOffset(customEvent.detail.isFixed ? 104 : 24);
    };

    window.addEventListener('bottomPanelFixed', handleBottomPanelFixed);

    return () => {
      window.removeEventListener('bottomPanelFixed', handleBottomPanelFixed);
    };
  }, []);

  useEffect(() => {
    const handleMainChatOpen = () => {
      setShowChat(false);
    };

    const handleMainChatClose = () => {
      setShowChat(true);
    };

    window.addEventListener('mainChatOpen', handleMainChatOpen);
    window.addEventListener('mainChatClose', handleMainChatClose);

    return () => {
      window.removeEventListener('mainChatOpen', handleMainChatOpen);
      window.removeEventListener('mainChatClose', handleMainChatClose);
    };
  }, []);

  const handleClick = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    window.dispatchEvent(new Event('mainChatClose'));
  };

  if (!shouldShowChatWidget) {
    return null;
  }

  return (
    <>
      <ChatContainer
        optVariant="chatWidget"
        showChat={showChat}
        openModal={openModal}
        sx={{ bottom: `${bottomOffset}px !important` }}
      >
        <FabButton onClick={handleClick}>
          <WhiteChatIcon />
        </FabButton>
      </ChatContainer>

      <ChatComponent
        topic=""
        isOpen={openModal}
        onClose={handleCloseModal}
      />
    </>
  );
};

export default ChatWidget;